import { getAuthCode } from "./getAuthCode";
export const fetchFreeTrialDays = async () => {
    try {
      let url = process.env.REACT_APP_BACKEND_URL + "/fetchTrialDaysLeft";
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body:JSON.stringify({auth_code:await getAuthCode()})
      });
      const result = await response.json();
      return result.daysLeft
    } catch (error) {
      console.log(error);
    }
  };